import Vue from 'vue'
import dayjs from 'dayjs'

// Torna acessível globalmente como this.$dayjs
Vue.prototype.$dayjs = dayjs
